<template>
  <div>
    <template v-if="authCheck">
      <p>{{ $t("error_alert_text") }}</p>
      <br />
      <b-button variant="success" v-on:click.prevent="reloadPage">{{
        $t("reload_page")
      }}</b-button>
    </template>
    <template v-else>
      <p
        class="
          text-grey-darker text-2xl
          md:text-3xl
          font-light
          mb-8
          leading-normal
        "
      >
        {{ $t("page_not_found") }}
      </p>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'error-import',
  computed: {
    ...mapGetters({
      authCheck: 'authCheck',
    }),
  },
  methods: {
    reloadPage() {
      window.location.reload()
    },
  },
}
</script>
